import { motion } from "framer-motion";
import { Clock, Flame } from "lucide-react";

export default function UrgencyBanner() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="flex items-center gap-3 p-4 rounded-xl border border-amber-500/25 bg-amber-500/[0.04]"
      data-testid="urgency-banner"
    >
      <div className="w-10 h-10 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center">
        <Flame size={18} className="text-amber-400" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-white font-medium text-sm">
          Taking only <span className="text-amber-300">3 new clients</span> this month
        </p>
        <p className="text-white/55 text-xs mt-0.5 flex items-center gap-1.5">
          <Clock size={11} /> Discovery calls booked within 24 hours of submission
        </p>
      </div>
    </motion.div>
  );
}
